export type TreasuryAccountType = "cash" | "mobile_money" | "bank";

export type PaymentMethod = "cash" | "mobile_money" | "bank_transfer" | "card";

export interface TreasuryAccount {
  id: string;
  type: TreasuryAccountType;
  name: string;
  balance: number;
  /** Banque ou opérateur (affichage). */
  institution: string;
  accountNumber: string;
  active: boolean;
  createdAt: string;
}

export interface TreasuryMovement {
  id: string;
  accountId: string;
  type: "credit" | "debit";
  amount: number;
  label: string;
  billingDocumentId: string | null;
  paymentMethod: PaymentMethod;
  reference: string;
  createdAt: string;
}

export const PAYMENT_METHOD_LABELS: Record<PaymentMethod, string> = {
  cash: "Espèces",
  mobile_money: "Mobile Money",
  bank_transfer: "Virement bancaire",
  card: "Carte bancaire",
};

export const TREASURY_ACCOUNT_TYPE_LABELS: Record<TreasuryAccountType, string> = {
  cash: "Caisse",
  mobile_money: "Mobile Money",
  bank: "Compte bancaire",
};

/** Comptes crédités selon le mode de paiement. */
export const PAYMENT_METHOD_ACCOUNT_TYPES: Record<PaymentMethod, TreasuryAccountType[]> = {
  cash: ["cash"],
  mobile_money: ["mobile_money"],
  bank_transfer: ["bank"],
  card: ["bank"],
};
